import { render, staticRenderFns } from "./PetProject.vue?vue&type=template&id=916be9cc&scoped=true&"
import script from "./PetProject.vue?vue&type=script&lang=js&"
export * from "./PetProject.vue?vue&type=script&lang=js&"
import style0 from "./PetProject.vue?vue&type=style&index=0&id=916be9cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "916be9cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VIcon,VRow})
